exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".full {\n  height: 100%; }\n\n.half {\n  height: 50%; }\n\n.closed {\n  height: 0%; }\n\n.search-box-placer {\n  position: relative; }\n\n.search-box-placer i {\n  position: absolute;\n  right: 18px;\n  top: 27px;\n  font-size: 1.2rem;\n  color: #ccc;\n  cursor: pointer; }\n\ninput.search-box {\n  width: 340px;\n  height: 48px;\n  margin: 10px 0;\n  border: 1px solid #efefef;\n  font-size: 0.9rem;\n  padding: 0 51px 0 18px;\n  font-weight: normal;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/maps/maps.component.scss
// module id = 1290
// module chunks = 0